import Modal from "react-bootstrap/Modal";
import { styleEnd } from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import { useState } from "react";
import FileUploader from "../reusableComponents/fileUploader";
import { useFormik } from "formik";
import {
  formikSetup,
  initialValues,
  validationSchema,
} from "./formikValidation";
import Alerts from "../reusableComponents/alert";
import FilesList from "../reusableComponents/filesList";
import Button from "../sharedComponents/buttons/button";
import { addAttachmentForm } from "../../API/store/actions/tasks";
import { useSelector } from "react-redux";
import "./tasksStyle.css";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";

const AddTaskAttachments = (props) => {
  const {
    onHide,
    taskId,
    procedureId,
    activityId,
    activityProcId,
    projectId,
    subTaskId,
    subProcedureId,
    setProcAdded,
    procAdded,
  } = props;

  const [files, setFiles] = useState([]);
  const userToken = useSelector((state) => state.login.userToken);

  const [error, setError] = useState(false);
  const [duplicateAlert, setDuplicateAlert] = useState(false);
  const [noFilesAlert, setNoFilesAlert] = useState(false);
  const [disable, setDisable] = useState(false);

  const saveHandler = async (values) => {
    let formData = new FormData();
    const newData = {
      AttachmentFiles: values.AttachmentFiles,
    };

    for (let [key, value] of Object.entries(newData)) {
      if (key == "AttachmentFiles") {
        value.forEach((element) => {
          formData.append("AttachmentFiles", element.file);
        });
      }
    }

    if (files.length > 0) {
      setError(false);
      if (disable) {
        return;
      } else {
        setDisable(true);
      }
      let res;
      if (taskId)
        res = await addAttachmentForm(
          taskId,
          null,
          null,
          null,
          null,
          null,
          null,
          formData,
          userToken
        );
      else if (activityId)
        res = await addAttachmentForm(
          null,
          null,
          activityId,
          null,
          null,
          null,
          null,
          formData,
          userToken
        );
      else if (activityProcId)
        res = await addAttachmentForm(
          null,
          null,
          null,
          activityProcId,
          null,
          null,
          null,
          formData,
          userToken
        );
      else if (projectId)
        res = await addAttachmentForm(
          null,
          null,
          null,
          null,
          projectId,
          null,
          null,
          formData,
          userToken
        );
      else if (subTaskId)
        res = await addAttachmentForm(
          null,
          null,
          null,
          null,
          null,
          subTaskId,
          null,
          formData,
          userToken
        );
      else if (subProcedureId)
        res = await addAttachmentForm(
          null,
          null,
          null,
          null,
          null,
          null,
          subProcedureId,
          formData,
          userToken
        );
      else
        res = await addAttachmentForm(
          null,
          procedureId,
          null,
          null,
          null,
          null,
          null,
          formData,
          userToken
        );

      if (res.status <= 206) {
        setFiles([]);
        setProcAdded(!procAdded);
        resetForm();
        onHide();
        setDisable(false);
      } else {
        setDisable(false);
      }
    } else {
      setError(true);
      setDisable(false);
    }
  };

  const formik = useFormik(
    formikSetup(
      initialValues,
      undefined,
      validationSchema,
      "addAttachment",
      saveHandler
    )
  );

  const { handleSubmit, setFieldValue, values, setFieldTouched, resetForm } =
    formik;

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              className="mx-2 d-flex justify-content-center align-items-center"
              style={{
                height: 32,
                width: 32,
              }}
            >
              <img src="/assets/images/Group 8269.png" width={30} height={30} />
            </div>
            <div className="text-dark">
              <p
                className="my-0 mx-1"
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "#1a73e8",
                }}
              >
                {Lang.addAttachments}
              </p>
            </div>
          </div>
        </Modal.Title>
        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"#1A73E8"}
            onclick={() => {
              onHide();
              setFiles([]);
              resetForm();
              setError(false);
              setDisable(false);
            }}
          />
        </div>
      </Modal.Header>

      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <form onSubmit={handleSubmit}>
          <div className="col-12 px-4 px-xl-5">
            <Alerts
              variant={"danger"}
              buttonContent={
                getDir(getCurrentLangFromRedux()) == "rtl" ? "إغلاق" : "close"
              }
              content={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? "هذا الملف تم رفعه من قبل"
                  : "this file uploaded already"
              }
              title={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? "ملف متكرر"
                  : "duplicate file"
              }
              show={duplicateAlert}
              setShow={setDuplicateAlert}
            />
            <Alerts
              variant={"danger"}
              buttonContent={
                getDir(getCurrentLangFromRedux()) == "rtl" ? "إغلاق" : "close"
              }
              content={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? "برجاء رفع بعض الملفات"
                  : "please upload some files"
              }
              title={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? "لا يوجد ملفات"
                  : "No Files Here"
              }
              show={noFilesAlert}
              setShow={setNoFilesAlert}
            />
          </div>

          <div className="d-flex flex-column mx-4 px-xl-4 mb-3">
            <FileUploader
              containerStyle={"col-12"}
              contentStyle={"col-12"}
              borderColor={"#C7C7C9"}
              placeholderLTRWidth={150}
              placeholderRTLWidth={115}
              fileIconColor={"#1a73e8"}
              fileValue={values.file}
              fileOnClick={(e) => {
                e.target.value = "";
                setFieldValue("file", e.target.value);
              }}
              FileOnChange={(e) => {
                setFieldValue("file", e.target.files[0]);
              }}
              uploadButtonOnChange={() => {
                if (values.file) {
                  if (
                    !files.find(
                      (item) => item.fileName === values.file.name.substr(0, 35)
                    )
                  ) {
                    const allFiles = [
                      ...files,
                      {
                        id: files.length + 1,
                        fileName: values.file.name.substr(0, 35),
                        file: values.file,
                      },
                    ];
                    setFieldValue("AttachmentFiles", [...allFiles]);
                    setFiles([...allFiles]);
                    setFieldValue("file", "");
                    setFieldTouched("AttachmentFiles", false);
                    setError(false);
                  } else {
                    setDuplicateAlert(true);
                    setTimeout(() => {
                      setDuplicateAlert(false);
                    }, 1000);
                  }
                } else {
                  setNoFilesAlert(true);
                  setTimeout(() => {
                    setNoFilesAlert(false);
                  }, 1000);
                }
              }}
            />
            <FilesList
              containerStyle={"col-12 justify-content-start"}
              contentStyle={"col-12"}
              Data={[...files]}
              setFiles={setFiles}
              setFilesInFormik={setFieldValue}
              setFilesTouched={setFieldTouched}
              error={error}
              setError={setError}
              propInFormik={"AttachmentFiles"}
            />
          </div>

          <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
            <Button
              disable={disable}
              content={disable ? Lang.saving : Lang.save}
              containerStyle="col-3 mx-3"
              onClick={() => {
                if (files.length) setError(false);
              }}
              type={"submit"}
              buttonStyleType={"solid"}
            />

            <Button
              content={Lang.cancel}
              containerStyle="col-3 mx-3"
              onClick={() => {
                onHide();
                setFiles([]);
                resetForm();
                setError(false);
                setDisable(false);
              }}
            />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};
export default AddTaskAttachments;
